var Base = require('front/components/Base/Base');
var _ = require('underscore');

require('./Casting.less');

module.exports = Base.extend({
    el: '.Casting',

    initialize: function () {
        this.$el.closest('body').css({
            'overflow-y': 'hidden'
        });

        $('.Content-footer').css({
            'display': 'none'
        });

        this.$el.closest('body').find('.Content-body').css({
            'display': 'none'
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Casting/Casting.js
// module id = 185
// module chunks = 0